import api from './api';

export const getSettings = () => api.get('/settings');
export const updateSetting = (key, value) => api.put('/settings', { key, value });
export const getShopInfo = () => api.get('/settings/shop');
export const updateShop = (shopData) => api.put('/settings/shop', shopData);
export const updateFinancial = (financialData) => api.put('/settings/financial', financialData);
export const updateReceipt = (receiptData) => api.put('/settings/receipt', receiptData);
export const updateNotifications = (notifData) => api.put('/settings/notifications', notifData);
export const updateAppearance = (appearanceData) => api.put('/settings/appearance', appearanceData);
export const uploadLogo = (formData) => api.post('/settings/logo', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const getSystemInfo = () => api.get('/settings/system');
